import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {LayerWithWorkingProps} from 'common/src/modules/movieEditor/movieEditor.types';
import {getLayerWithUniqueName} from 'common/src/modules/creativeTemplates/store/creativeTemplatePage/formatMovies/utils/getLayerWithUniqueName';
import appendLayers from './appendLayers';
import {RootState} from 'common/src/redux/store';
import {getActiveFormat} from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/utils/getActiveFormat';

interface DuplicateLayersParams {
  layers: LayerWithWorkingProps[];
}

const duplicateLayers = createAsyncThunk(
  `${BreadcrumbName.AdBuilder}/duplicateLayers`,
  async ({layers}: DuplicateLayersParams, {dispatch, getState}): Promise<string[]> => {
    const state = getState() as RootState;
    const workingFormat = getActiveFormat();
    const comps = state.creativeTemplatePage.formatMovies.movies[workingFormat] || {};
    const activeCompId = state.creativeTemplatePage.formatMovies.activeCompId;
    const compLayers = comps[activeCompId]?.l || [];

    const sortedLayers = [...layers].sort((a, b) => Number(a.i) - Number(b.i));

    const layersToDuplicate = sortedLayers.map((layer, index) => ({
      ...layer,
      mappingId: Math.floor(Math.random() * 1e8),
      name: getLayerWithUniqueName(compLayers, layer.name, index),
    }));

    const insertIdx = Math.min(...sortedLayers.map((l) => Number(l.i)));

    const newIds = await dispatch(
      appendLayers({
        layers: layersToDuplicate,
        insertIdx,
      }),
    ).unwrap();

    return newIds;
  },
);

export default duplicateLayers;
